import { TopEdgeCut } from "./../utils/top-edge-cut";
import { UtilsBuilder } from "./utils-builder";
import { ProjectData } from "../entities/project-data.entity";
import { ProjectDataPresupuesto } from "../entities/project-data-presupuesto-entity";
import { ProjectDataPerimetro } from "../entities/project-data-perimetro.entity";
import { ConfigService } from "../app.config";
import { GestorDatas3d } from "./scheme3d/gestor-datas3d";
import { Datas3d } from "./scheme3d/datas3d";
import { DB } from "../datas/db";
import { SubSection } from "./scheme3d/sub-section";

import { LoggerService } from "../services/logger.service";

export class Budget {
	// Modelos de Verjas.
	// panelLength must match 'length' of each family defined at app/builder/scheme3d/panels3d.ts
	public readonly Verjas = {
		"BRICO-FAX": { idElemento: "interm_50", panelLength: 2.53 },
		FAX: { idElemento: "interm_50", panelLength: 2.53 },
		"FAX DH": { idElemento: "interm_50", panelLength: 2.53 },
		"MAXI-FAX": { idElemento: "interm_80", panelLength: 2.64 },
		RITMO: { idElemento: "interm", panelLength: 2.53 },
		"RITMO DH": { idElemento: "interm", panelLength: 2.53 },
		RITMOCLIP: { idElemento: "interm", panelLength: 2.504 },
		CLASSIC: { idElemento: "interm", panelLength: 2.835 },
		NATURE: { idElemento: "interm", panelLength: 2.57 },
		NATURE_CUADRADO: { idElemento: "interm", panelLength: 2.545 },
		CALITAX: { idElemento: "interm", panelLength: 2.835 },
		CALITAX_CUADRADO: { idElemento: "interm", panelLength: 2.815 },
		NOVE: { idElemento: "interm", panelLength: 2.565 },
		NOVE_CUADRADO: { idElemento: "interm", panelLength: 2.55 },
		ULTRA: { idElemento: "interm", panelLength: 2.835 },
		ULTRA_CUADRADO: { idElemento: "interm", panelLength: 2.815 },
		DECOR: { idElemento: "interm", panelLength: 2.835 },
		DECOR_CUADRADO: { idElemento: "interm", panelLength: 2.815 },
	};

	// Mensajes que se retornan como resultado de la creación del presupuesto.
	public readonly MessageError = {
		OK: { message: "Budget: Ok." },
		Undefined: { message: "Budget: Projecto undfined." },
		Empty: { message: "Budget: Projecto sin perímetros." },
		LengthExceeded: {
			message: "Budget: Longitud del perímetro superior al permitido.",
		},
		NeedIdUser: { message: "Budget: Falta el identidicador del usuario." },
		UnknownFamily: { message: "La familia no tiene tipo." },
		ServerError: { message: "Retorno del servidor con error." },
		DontMakeIt: {
			message:
				"No se ha podido crear el pedido para que lo ejecute el servidor.",
		},
	};

	private _statusBudget = 0; // 0 = ok, 1 = problemas conexión.
	private _proccessEnd = true; // Indica si el gestor teermino.
	public get proccessEnd() {
		return this._proccessEnd;
	}

	// Proyecto a procesar.
	private projectData: ProjectData;

	public gestor: GestorDatas3d;

	// Utilidades para calculos de perímetros.
	private utilsBuilder: UtilsBuilder;

	// Resultado que se retorna.
	// error        : Retorna código del error o 0 si todo fue bien.
	public result = {
		error: this.MessageError.OK,
		lengthExceeded: false,
	};

	// #########################################################################
	// #########################################################################
	// Constructor.
	public constructor(projectData: ProjectData) {
		this.projectData = projectData;
	}

	// Reinicia los valores del objeto de retorno.
	private _clearResult() {
		(this.result.error = this.MessageError.OK),
			(this.result.lengthExceeded = false);
	}

	// Crear el presupuesto desde el esquema.
	public createBudget(): boolean {
		// Reiniciar objeto de retorno.
		this._clearResult();

		// Si no hay projecto rechazar.
		if (!this.projectData) {
			this.result.error = this.MessageError.Undefined;
			return false;
		}

		// Debe tener un identifcador de usuario.
		if (!this.projectData.userId || this.projectData.userId == "") {
			this.result.error = this.MessageError.NeedIdUser;
			return false;
		}

		// Obtener la suma de todas las longitudes de todos los perímetros.
		// Si no hay perímetros definidos rechazar.
		if (
			!this.projectData.perimetro ||
			this.projectData.perimetro.length == 0
		) {
			this.result.error = this.MessageError.Empty;
			return false;
		}
		let perimeterTotalLength = 0;
		for (let p of this.projectData.perimetro) {
			perimeterTotalLength += p.longitud;
		}

		// Divisor de tramos, particiona los tramos de los perímetros en secciones.
		this.gestor = new GestorDatas3d(true);
		this.gestor.insertNo3D(this.projectData);

		// Comprobar si el perímetro es más largo de lo permitido.
		// Se sigue adelante con el presupuesto pero se le avisa.
		this.result.lengthExceeded =
			perimeterTotalLength > ConfigService.MAX_PERIMETER_LENGTH_METERS;

		// Si es true todo fue bien y se pide el presupuesto.
		let allRight = false;

		// Controlador y calculador de perímetros.
		this.utilsBuilder = new UtilsBuilder();

		// Bucle principal, lee todos los perímetros.
		for (
			let index = 0;
			index < this.projectData.perimetro.length;
			index++
		) {
			let perimetro = this.projectData.perimetro[index];
			let perimetroDatas = this.gestor.datas[index];

			// Crear un presupuesto limpio.
			perimetro.presupuesto = new ProjectDataPresupuesto();

			// Almacenar la información 3D asociada al perímetro
			// (necesaria para determinat ciertos elementos que dependen 
			// del tamaño y posicionamiento de los elementos para ser tenidos 
			// en cuenta o no para el presupuesto)
		   perimetro.presupuesto.dataCoors3D = perimetroDatas.coors;
			
		   // Actualiza perímetro cerrado, arrays ang1 y ang2.
			this.utilsBuilder.iniciar(perimetro.coordenadas);

			perimetro.presupuesto.unity.ml = perimetro.longitud;

			// Bifurcar según Familia.
			if (perimetro.producto.familia.tipo === DB.CERCADO) {
				allRight = this.__CERCADOS(perimetro, this.gestor.datas[index]);
			} else if (perimetro.producto.familia.tipo === DB.VERJA) {
				allRight = this.__VERJAS(perimetro, this.gestor.datas[index]);
			} else {
				console.error(this.MessageError.UnknownFamily.message);
			}
		}

		// Enviar al servidor.
		if (!allRight) {
			// No se ha podido crear el pedido para que lo ejecute el servidor.
			this.result.error = this.MessageError.DontMakeIt;
		}

		return allRight;
	}

	// ##################################################################### CERCADOS
	private __CERCADOS(
		perimetro: ProjectDataPerimetro,
		datas3d: Datas3d
	): boolean {
		let _producto = perimetro.producto;
		let _tipoPanel = perimetro.producto.tipoPanel;
		let _panel = perimetro.producto.panel;
		let _informacion = perimetro.informacion;
		let _presupuesto = perimetro.presupuesto;

		let rects = 0; // Tramo recto. CON PIES (LUX)
		let interms = 0; // Total de postes internos del perímtero. (LUX)
		let rects_des = 0; // postes normales.
		let extremoIzq = 0; // poste límite izquierdo.
		let extremoDer = 0; // poste límite derecho.

		//'LUX_ANUDADA': { 'extr.i_50', 'extr.d_50', 't.ang_50', 't.int_50', 'interm_50', 't.rect_50' } // 100, 150, 200
		// if (perimetro.producto.tipoPanel.modeloStr !== this.CERCADO_ANUDADA) POR DEFECTO.
		let interm = "interm_50";
		let extr_i = "extr.i_50";
		let extr_d = "extr.d_50";
		let t_ang = "t.ang_50";
		let t_int = "t.int_50";
		let t_rect = "t.rect_50";

		//'LUX_ELECTRO': { 'extr.i_50', 'extr.d_50', 't.ang_50', 't.int_50', 'interm_50', 't.rect_50' }, // 100x50 -> 100
		//'LUX_ELECTRO': { 'extr.i_80', 'extr.d_80', 't.ang_80', 't.int_80', 'interm_50', 't.rect_80' }, // 100x50 -> 150 | 50x50 -> 150 200
		//'LUX_ELECTRO': { 'extr.i_80', 'extr.d_80', 't.ang_80', 't.int_80', 'interm_80', 't.rect_80' }, // 100x50 -> 200 |
		if (_tipoPanel.modeloStr === DB.CERCADO_ELECTRO) {
			if (_panel.alturaValor > 1000) {
				if (
					_panel.alturaValor === 2000 &&
					_panel.medidaMalla === "100x50"
				)
					interm = "interm_80";
				extr_i = "extr.i_80";
				extr_d = "extr.d_80";
				t_ang = "t.ang_80";
				t_int = "t.int_80";
				t_rect = "t.rect_80";
			}
		}
		//1 15 2(50) anchuraPoste
		//'LUX_EXT': { 'extr.i_50', 'extr.d_50', 't.ang_50', 't.int_50', 'interm_50', 't.rect_50' },
		//2(80) 3 4
		//'LUX_EXT': { 'extr.i_80', 'extr.d_80', 't.ang_80', 't.int_80',  'interm_80',  't.rect_80' },
		else if (_tipoPanel.modeloStr === DB.CERCADO_LUX_EXT) {
			if (
				(_panel.alturaValor === 2000 &&
					_producto.anchuraPoste &&
					_producto.anchuraPoste === "LUX80") ||
				_panel.alturaValor > 2000
			) {
				interm = "interm_80";
				extr_i = "extr.i_80";
				extr_d = "extr.d_80";
				t_ang = "t.ang_80";
				t_int = "t.int_80";
				t_rect = "t.rect_80";
			}
		}

		// Empezar bucle para calcular los tramos. Solo hay que sacar los postes intermedios y tener en cuenta las puertas y escalones.
		if (perimetro.coordenadas.length > 1) {
			// Si el perímetro está abierto, asignar los extremos izquierdo y derecho.
			if (!this.utilsBuilder.cerrado) {
				extremoIzq++;
				extremoDer++;
			}

			//let lastTramo: any;
			let lastSeccion: any;

			// Procesar tramos.
			for (
				let indexTramo = 0;
				indexTramo < datas3d.coors.length - 1;
				indexTramo++
			) {
				let tramo = datas3d.coors[indexTramo];
				// Procesar secciones.
				for (
					let indexSeccion = 0;
					indexSeccion < tramo.sections.length;
					indexSeccion++
				) {
					let seccion: SubSection = tramo.sections[indexSeccion];
					let auxInt = 0; // Reiniciar postes rectos.
					// ### NO ES UNA PUERTA.
					if (seccion.door === "") {
						// No es una puerta.
						let p = seccion.magnitud;
						if (_tipoPanel.modeloStr === DB.CERCADO_ANUDADA) {
							// LUX_ANUDADA.
							if (p >= 56) auxInt = Math.floor(p / 56);
							interms += Math.floor(p / 6) - auxInt; // Postes simples.
						} else {
							// LUX_EST o LUX_ELECTRO.
							if (p >= 30) auxInt = Math.floor(p / 30);
							interms += Math.floor(p / 3) - auxInt; // Postes simples.
						}
						//section.height;
						rects += auxInt; // Sumo postes rectos al general.

						// Calcular el poste inicial de los tramos.
						if (indexSeccion > 0 && lastSeccion.door === "")
							rects_des++;
					}
					// ### ES UNA PUERTA.
					else {
						// Si la puerta tiene overflow no incluir los postes extremoIzq y extremoDer.
						if (!(seccion.overflowLeft || seccion.overflowRight)) {
							// Añade poste Izq y poste Der.
							extremoIzq++;
							extremoDer++;
						}
					}

					lastSeccion = seccion; // Cache de la última sección.
				}
			}

			// Computar angulos.
			interms += this.utilsBuilder.computarAngulos();

			// Angulos Externos.
			if (this.utilsBuilder.angulosExternos > 0)
				_presupuesto.unity.elementos.push({
					idElemento: t_ang,
					altura: _panel.altura,
					cantidad: this.utilsBuilder.angulosExternos,
				});
			// Angulos Internos.
			if (this.utilsBuilder.angulosInternos > 0)
				_presupuesto.unity.elementos.push({
					idElemento: t_int,
					altura: _panel.altura,
					cantidad: this.utilsBuilder.angulosInternos,
				});
			// Postes intermedios.
			if (interms > 0)
				_presupuesto.unity.elementos.push({
					idElemento: interm,
					altura: _panel.altura,
					cantidad: interms,
				});
			// Postes con tornapuntas.
			if (rects > 0)
				_presupuesto.unity.elementos.push({
					idElemento: t_rect,
					altura: _panel.altura,
					cantidad: rects,
				});
			// Postes con tornapuntas altos.
			if (rects_des > 0)
				_presupuesto.unity.elementos.push({
					// ESPRRIVISA-130: Push id, height and quantity of t_rect with unevenness
					idElemento: t_rect + "_des",
					altura: _panel.altura,
					cantidad: rects_des,
				});
			// Extermo izquierdo con tornapuntas.
			if (extremoIzq > 0)
				_presupuesto.unity.elementos.push({
					idElemento: extr_i,
					altura: _panel.altura,
					cantidad: extremoIzq,
				});
			// Extermo derecho con tornapuntas.
			if (extremoDer)
				_presupuesto.unity.elementos.push({
					idElemento: extr_d,
					altura: _panel.altura,
					cantidad: extremoDer,
				});

			_presupuesto.unity.ml = perimetro.longitud;
			_presupuesto.unity.mlStr = perimetro.longitud.toString();

			if (_producto.tipoBayoneta !== "no") {
				_presupuesto.unity.cantidadBayonetas =
					this.utilsBuilder.angulosExternos +
					this.utilsBuilder.angulosInternos;
				_presupuesto.unity.cantidadBayonetas +=
					interms + rects + rects_des + extremoIzq + extremoDer;
			}

			if (document.location.origin.includes("localhost:7890"))
				LoggerService.showDebug(
					"_presupuesto.unity: ",
					_presupuesto.unity,
					{ _panel },
					"_panel.altura: ",
					_panel.altura,
					{ interm },
					{ rects },
					{ rects_des },
					{ extremoIzq },
					{ extremoDer }
				);
		}
		return true;
	}

	// ##################################################################### VERJAS
	private __VERJAS(
		perimetro: ProjectDataPerimetro,
		datas3d: Datas3d
	): boolean {
		// 1 15 2 'BRICO-FAX': { 'interm_50' }
		// 06 1 12 15 18 2 'FAX': { 'interm_50' }
		// 1 12 14 16 18 2 'FAX DH': { 'interm_50' }
		// 15 2 24 'MAXI-FAX' { 'interm_50' }
		// 06 08 1 12 15 18 2 24 'RITMO' { 'interm' }
		// 1 12 14 16 18 2 'RITMO DH' { 'interm' }
		// 06 1 12 15 18 2 'RITMOCLIP' { 'interm' }
		// 06 1 15 2 'CLASSIC' { 'interm' } "cantidadComodines":4,
		// 1 15 2 'CALITAX' { 'interm' }
		// 06 1 15 'NOVE' { 'interm' } "cantidadComodines":4,
		// 1 15 2 'ULTRA' { 'interm' }
		// 06 1 15 2 'DECOR' { 'interm' }
		// 1 12 15 18  2 24 'NATURE' { 'interm' }
		// No se pueden permitir perímetros de un solo punto.
		if (perimetro.coordenadas.length < 2) return false;

		let _tipoPanel = perimetro.producto.tipoPanel;
		let _panel = perimetro.producto.panel;
		let _informacion = perimetro.informacion;
		let _presupuesto = perimetro.presupuesto;

		LoggerService.showDebug(perimetro);

		// Obtener la verja.
		let bIsSquare = perimetro.producto.tipoPoste.indexOf("Cuadrado") != -1;
		let completePanelString = _tipoPanel.modeloStr;
		if (bIsSquare) {
			completePanelString += "_CUADRADO";
		}

		let verja = this.Verjas[completePanelString];
		if (!verja) return false;

		// Calcular los postes.
		let cantidadPostes = 0;
		let cantidadPostes_des = 0;
		let cantidadPostes_dob = 0;
		let cantidadPostes_dob_des = 0;
		let lastElevation = 0.0;
		let currentElevation = 0.0;
		let elevationUpdatedInTramo = 0.0;
		let cantidadPanelesRecortados = 0;

		let bRecuento: boolean = false;
		let bClosedPermInitialPoleIsHigher: boolean = false;

		let topEdgeCut: number = undefined;

		// Empezar bucle para calcular los tramos. Solo hay que sacar los postes intermedios y tener en cuenta las puertas y escalones.
		if (perimetro.coordenadas.length > 1) {
			let lastSeccion: any;

			// Procesar tramos.
			for (
				let indexTramo = 0;
				indexTramo < datas3d.coors.length - 1;
				indexTramo++
			) {
				let tramo = datas3d.coors[indexTramo];
				// Procesar secciones.
				for (
					let indexSeccion = 0;
					indexSeccion < tramo.sections.length;
					indexSeccion++
				) {
					let seccion = tramo.sections[indexSeccion];

					// For the first section,
					if (indexSeccion === 0 && indexTramo === 0) {
						if (datas3d.closed) {
							// If perimeter is  closed, get for lastElevation from the last section of the last stench.
							// (The perimeter might end in a higher level, so the initial pole sholuld be higher!)
							let lastTramo =
								datas3d.coors[datas3d.coors.length - 2];
							let lastSection =
								lastTramo.sections[
									lastTramo.sections.length - 1
								];
							if (lastSection != undefined) {
								lastElevation = lastSection.height;
							}
						} else {
							// If perimeter is not closed, get for lastElevation the section elevation
							// instead of 0 (a wall might exist for the whole perimeter, so it's not
							// automatically a higher pole!)
							lastElevation = seccion.height;
						}
					}

					// ### NO ES UNA PUERTA.
					if (seccion.door === "") {
						// No es una puerta.
						currentElevation = seccion.height;

						// Check if remaining magnitud is too small to place a panel,
						// so the initial needs to be splitted
						let p =
							seccion.magnitud -
							(seccion.marginA + seccion.marginB);

						// Nmber of full Panels.
						let unidades = Math.floor(p / verja.panelLength);
						cantidadPostes += unidades;

						// Calcular el poste inicial de los tramos.
						// if (indexSeccion > 0 && lastSeccion.door === '') {
						// 	//LoggerService.showDebug('HAY POSTE CUADRADO');
						// 	cantidadPostes_des++;
						// }

						// Añadir un poste de tamaño superior (_des) si hay desnivel con respecto a la sección anterior
						// (que no sea una puerta, ya que éstas siempre están a ras de suelo)
						let bPosteDesCond1 =
							Math.abs(currentElevation - lastElevation) !== 0.0;
						if (bPosteDesCond1) {
							if (
								indexSeccion === 0 &&
								indexTramo === 0 &&
								datas3d.closed
							) {
								bClosedPermInitialPoleIsHigher = true;
							}
							cantidadPostes_des++;
						}

						// Añadir +1 poste si el tramo tiene poste addicional!
						// (Solo una vez, al legar al último subtramo)
						// El tamaño del poste lo marca la elevación!
						let bLastSubTramo =
							indexSeccion == tramo.sections.length - 1;
						let indexNextTramo =
							indexTramo == datas3d.coors.length - 2
								? 0
								: indexTramo + 1;
						let nextTramo = datas3d.coors[indexNextTramo];
						let bHasPosteAdd =
							nextTramo.posteAdicional !== undefined;
						let bIsXAssigned =
							nextTramo.posteAdicional.x !== undefined;
						let bIsYAssigned =
							nextTramo.posteAdicional.y !== undefined;
						let seccionPosteDoble = false;

						if (
							bLastSubTramo &&
							bHasPosteAdd &&
							bIsXAssigned &&
							bIsYAssigned
						) {
							// Si el objeto poste addicional no es undefined, comprobar si x e y
							// tienen valor asignado (o solamente existe el objeto, pero los valores
							// son undefined)

							//if(  ){
							seccionPosteDoble = true;
							//let nextElevation = nextTramo.sections[0].height;
							//let bNextPosteDesCond1 = ( Math.abs(currentElevation - nextElevation) !== 0.0 );

							//if( bNextPosteDesCond1 ) {
							//	cantidadPostes_dob_des++;
							//} else {
							cantidadPostes_dob++;
							//}
							//}
						}

						if (!seccionPosteDoble) {
							// Atención! si se define un escalon dentro del tramo, pero el desnivel entre ambas subsecciones es el mismo,
							// "realmente" no haye scalón, pero el configurador corta ese tramo en dos partes, lo que puede llegar a generar
							// un descuadre entre los postes que se representan en el 3D y los que aparecen en el presupuesto.

							// Comprobar primero si la magnitud es menor que la distancia mínima entre postes dobles (por si se está evaluando
							// la última sección de un tramo, que pertenece a un poste doble, y por algún motivo, el objeto posteAdicional
							// no se ha rellenado correctamente)
							let distanciaMinimaPosteDoble = 0.084852813742385702928101323452582;
							let distanciaThreshold = 0.001;
							let isMagnitudTooShort =
								Math.abs(
									seccion.magnitud - distanciaMinimaPosteDoble
								) < distanciaThreshold;
							if (!isMagnitudTooShort) {
								let bSameDesnivel =
									currentElevation == lastElevation;
								if (
									bSameDesnivel &&
									indexSeccion > 0 &&
									lastSeccion.door === ""
								) {
									if (bPosteDesCond1) {
										cantidadPostes_des++;
									} else {
										cantidadPostes++;
									}
								}
							}
						}

						let bUpdateElevation =
							Math.abs(currentElevation - lastElevation) !== 0.0;
						if (bUpdateElevation) {
							lastElevation = currentElevation;
							elevationUpdatedInTramo = indexTramo;
						}
					}
					// ### ES UNA PUERTA.
					else {
						// Evaluamos la posicion de la puerta
						if (tramo.sections.length == 1) {
							LoggerService.showDebug("PUERTA OCUPA TODO");
						} else if (tramo.sections.length == 2) {
							LoggerService.showDebug("PUERTA A LA IZQ O DER");
							// ESPRRIVISA-4. Activamos la funcionalidad de recuento con nuevo algoritmo para contar postes
							bRecuento = true;
						} else if (tramo.sections.length > 2) {
							//Comprobamos si esta a izquierda o derecha del todo
							//if(indexTramo > 0 && indexTramo < tramo.sections.length - 1) {
							if (
								indexSeccion > 0 &&
								indexSeccion < tramo.sections.length - 1
							) {
								LoggerService.showDebug("PUERTA EN EL MEDIO");
							} else {
								LoggerService.showDebug(
									"PUERTA AL INICIO O FINAL"
								);
								bRecuento = true;
							}
						}

						// Añade poste Izq y poste Der.
						if (tramo.sections.length <= 2) {
							cantidadPostes += 1;
						} else {
							cantidadPostes += 2;
						}
					}
					lastSeccion = seccion; // Cache de la última sección.
				}
			}
			// Se añaden los postes base, si está cerrado se resta un poste base.
			cantidadPostes += this.utilsBuilder.cerrado
				? perimetro.tramos.length - 1
				: perimetro.tramos.length;

			//If closed and the initial pole is Higher, subtract one pole from regular ones (it has been counted as Higher)
			cantidadPostes -= bClosedPermInitialPoleIsHigher ? 1 : 0;

			// TO-DO: El siguiente código solo se usa para las incidencias que no cuenta correctamente el codidgo principal de conteo de postes (ESPRRIVISA-4)
			// En algun momento deberia quedarse como el único que hace esta tarea de conteo
			// INIT - Algoritmo alternativo para contar postes
			if (bRecuento) {
				LoggerService.showDebug(
					"Algoritmo alternativo para contar postes"
				);
				cantidadPostes = 0;
				cantidadPostes_des = 0;

				// No iteramos la ultima coor del array.
				for (
					let indexTramo = 0;
					indexTramo < datas3d.coors.length - 1;
					indexTramo++
				) {
					let tramo = datas3d.coors[indexTramo];

					if (
						tramo.sections[tramo.sections.length - 1].magnitud <=
						0.1
					) {
						LoggerService.showDebug(
							"Ultima seccion es poste doble"
						);
						cantidadPostes_des++;
					}

					for (
						let indexSeccion = 0;
						indexSeccion < tramo.sections.length;
						indexSeccion++
					) {
						let seccion = tramo.sections[indexSeccion];

						// Comprobamos que no es ni seccion estrecha ni puerta
						if (seccion.magnitud > 0.1 && seccion.door === "") {
							let p = seccion.magnitud;
							//LoggerService.showDebug('ni puerta ni tramo vacio');
							//Miramos si es el ultimo tramo de todos
							if (
								indexSeccion == tramo.sections.length - 1 &&
								indexTramo == datas3d.coors.length - 2
							) {
								if (datas3d.closed) {
									//LoggerService.showDebug('Es cerrado... miramos si la primera seccion era de tipo puerta')
									if (
										datas3d.coors[0].sections[0].door !== ""
									) {
										//LoggerService.showDebug('La primera secction es de tipo puerta')
										cantidadPostes +=
											Math.floor(p / verja.panelLength) +
											2;
									} else {
										cantidadPostes +=
											Math.floor(p / verja.panelLength) +
											1;
									}
								} else {
									//LoggerService.showDebug('Ultima seccion de tramo en circuito abierto');
									cantidadPostes +=
										Math.floor(p / verja.panelLength) + 2;
								}
							} else {
								// Si no lo es añadimos lo que esta estipulado
								cantidadPostes +=
									Math.floor(p / verja.panelLength) + 1;
							}

							if (indexSeccion + 1 <= tramo.sections.length - 1) {
								if (
									tramo.sections[indexSeccion + 1].door !== ""
								) {
									//LoggerService.showDebug('Seccion proxima es de tipo puerta');
									cantidadPostes++;
								}

								// // Comprobar si la siguiente sección cominza por una puerta (y añadir un post adicional!)
								// if( indexTramo + 1 < datas3d.coors.length - 1 ) {

								// }
							}

							
						} 
						// else {
						// 	// Es un tramo intermedio que comienza por una puerta. Añadimos un poste más
						// 	let bCond1 = ( indexTramo > 0 );
						// 	let bCond2 = ( indexSeccion == 0 );
						// 	let bCond3 = ( seccion.door !== "" );

						// 	if ( bCond1 && bCond2 && bCond3  ) {
						// 		cantidadPostes++;								
						// 	}
						// }
					}
				}
			}
			// END - Algoritmo alternativo para contar postes

			// Crear el pedido.
			_presupuesto.unity.ml = perimetro.longitud;

			LoggerService.showDebug({ datas3d }, { perimetro });

			// ESPRRIVISA-127 With CLASSIC and NOVE we need to create the field 'cantidadComodines', which will contain the number
			// of accessories needed. 1 accessory for each shortened panel.
			if (
				_tipoPanel.modeloStr === "CLASSIC" ||
				_tipoPanel.modeloStr === "NOVE"
			) {
				_presupuesto.unity.cantidadComodines = 0;
				let panelLength = datas3d.separation; // Length of the panel model.
				let tramos = datas3d.coors; // Array containing info about tramos.

				// Loop through tramos.
				for (
					let indexTramo = 0;
					indexTramo < tramos.length - 1;
					indexTramo++
				) {
					// Loop through sections of each tramo.
					for (
						let indexSection = 0;
						indexSection < tramos[indexTramo].sections.length;
						indexSection++
					) {
						let section = tramos[indexTramo].sections[indexSection]; // Array containing info about a section.
						let sectionLength = section.magnitud; // Length without unevenness of the section.

						if (section.door === "" && section.magnitud > 0.09) {
							// If the section is not a door and the section is > 0.09 - to not count when the section is a double post

							// Calculate how much length we have left for the last panel.
							let rest = sectionLength % panelLength;

							// If there is remaining length, means that there is gonna be at least one shortened panel,
							// so we add 1 accessory.
							if (rest != 0) {
								_presupuesto.unity.cantidadComodines += 1;
							}

							// If the remaining length its less that 30% of the length of a panel we need to add another accessory,
							// because the remainings will be distributed between the first panel and de last one.
							if (rest < panelLength * 0.3) {
								_presupuesto.unity.cantidadComodines += 1;
								LoggerService.showDebug(
									"After checking the 30%: ",
									_presupuesto.unity.cantidadComodines
								);
							}
						}
					}
				}

				LoggerService.showDebug(
					"CLASSIC / NOVE - total accessories:",
					_presupuesto.unity.cantidadComodines
				);
			}

			_presupuesto.unity.topEdgeCut = topEdgeCut;

			// ESPRRIVISA-150
			if (_tipoPanel.modeloStr === "ULTRA") {
				LoggerService.showDebug(
					"ULTRA only - topEdgeCut:",
					_panel.topEdgeCut
				);
				_presupuesto.unity.topEdgeCut = _panel.topEdgeCut;
			}

			_presupuesto.unity.cantidadBayonetas = cantidadPostes;
			_presupuesto.unity.cerrado = this.utilsBuilder.cerrado;

			// ESPRRIVISA-128: post backend calculation of _totalPostesFiltrados and so _paneles in budGetCtrl.js
			// to mactch the way it's done in budget-satelite.ts
			const quantityDoublePosts =
				cantidadPostes_dob + cantidadPostes_dob_des;

			if (cantidadPostes > 0) {
				_presupuesto.unity.elementos.push({
					idElemento: verja.idElemento,
					altura: _panel.altura,
					cantidad: cantidadPostes + cantidadPostes_dob,
					esPosteAdicional: false,
				});
			}

			if (cantidadPostes_des > 0) {
				_presupuesto.unity.elementos.push({
					idElemento: verja.idElemento + "_des",
					altura: _panel.altura,
					cantidad: cantidadPostes_des + cantidadPostes_dob_des,
					esPosteAdicional: false,
				});
			}

			// ESPRRIVISA-128: post backend calculation of _totalPostesFiltrados and so _paneles in budGetCtrl.js
			// to mactch the way it's done in budget-satelite.ts
			if (quantityDoublePosts > 0) {
				_presupuesto.unity.elementos.push({
					//"idElemento": verja.idElemento,
					//"altura": _panel.altura,
					quantity: quantityDoublePosts,
					esPosteAdicional: true,
				});
			}

			/*if (cantidadPostes_dob > 0) {
				_presupuesto.unity.elementos.push({
					"idElemento": verja.idElemento,
					"altura": _panel.altura,
					"cantidad": cantidadPostes_dob,
					"esPosteAdicional": true
				});
			}
			//
			if (cantidadPostes_dob_des > 0) {
				_presupuesto.unity.elementos.push({
					"idElemento": verja.idElemento + '_des',
					"altura": _panel.altura,
					"cantidad": cantidadPostes_dob_des,
					"esPosteAdicional": true
				});
			}*/

			LoggerService.showDebug(
				{ _panel },
				{ cantidadPostes },
				{ cantidadPostes_des },
				{ quantityDoublePosts },
				"verja.idElemento",
				verja.idElemento,
				{ _presupuesto }
			);
		}

		return true;
	}
}
